var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0V48H4V0H8Z",
    fill: "#E5FDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379 7.48633L10.9893 24L29.3379 40.5137L26.6621 43.4863L6.66211 25.4863V22.5137L26.6621 4.51367L29.3379 7.48633Z",
    fill: "#E5FDDD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 22V26H8V22H44Z",
    fill: "#E5FDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.52e0d072c61699a84d17af52baf7cfb6.svg";
export { ForwardRef as ReactComponent };